import Component from './component';

module.exports = Component;



// WEBPACK FOOTER //
// ./src/index.js